import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiHospitalAccountElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiHospitalAccountElFindParams, unknown>

const fetchHospitalAccountList = async (params: ApiHospitalAccountElFindParams) => {
  const { data } = await apiClient.v2.apiHospitalAccountElFind(params);
  return checkApiResponse(data);
}

export const hospitalAccountKeys = {
  all: [QUERY_KEY.v2apiHospitalAccountElFind] as const,
  list: (params: ApiHospitalAccountElFindParams) => [...hospitalAccountKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(hospitalAccountFindQueryOptions(params))` */
export const hospitalAccountFindQueryOptions = (params: ApiHospitalAccountElFindParams) => ({
  queryKey: hospitalAccountKeys.list(params),
  queryFn: () => fetchHospitalAccountList(params),
})

export const useHospitalAccountFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: hospitalAccountKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchHospitalAccountList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
